import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Loader from 'react-loader';
import { Container, Button } from 'reactstrap';
import Layout from '../components/Layout';
import PageNav from '../components/PageNav';
import { fetchEmployees } from '../modules/EmployeeList/actions';
import { isLoaded, getError } from '../modules/EmployeeList/reducer';
import EmployeeList from '../modules/EmployeeList';

class EmployeeListpage extends Component {
  componentDidMount() {
    this.props.fetchEmployees();
  }

  render() {
    const { isLoaded } = this.props;
    return (
      <Layout>
        <Container>
          <PageNav>
            <h1>Zaměstnanci</h1>
            <Button tag={Link} to="/zamestnanci/new" color="primary">
              Nový zaměstnanec
            </Button>
          </PageNav>
          <Loader loaded={isLoaded}>
            <EmployeeList />
          </Loader>
        </Container>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoaded: isLoaded(state),
    error: getError(state)
  };
};

export default connect(
  mapStateToProps,
  { fetchEmployees }
)(EmployeeListpage);



// WEBPACK FOOTER //
// ./src/pages/EmployeeListPage.js